"use strict";
import { isMainnetChainId } from "features/chains/utils";
import { DynamicConfigs, SwapConfigKey } from "features/gating/configs";
import { FeatureFlags } from "features/gating/flags";
import { useDynamicConfigValue, useFeatureFlag } from "features/gating/hooks";
import { ONE_SECOND_MS } from "utilities/src/time/time";
export const AVERAGE_L1_BLOCK_TIME_MS = 12 * ONE_SECOND_MS;
const AVERAGE_L2_BLOCK_TIME_MS = 3 * ONE_SECOND_MS;
export function usePollingIntervalByChain(chainId) {
  const averageL1BlockTimeMs = useDynamicConfigValue(
    DynamicConfigs.Swap,
    SwapConfigKey.AverageL1BlockTimeMs,
    AVERAGE_L1_BLOCK_TIME_MS
  );
  const averageL2BlockTimeMs = useDynamicConfigValue(
    DynamicConfigs.Swap,
    SwapConfigKey.AverageL2BlockTimeMs,
    AVERAGE_L2_BLOCK_TIME_MS
  );
  const enableTwoSecondInterval = useFeatureFlag(FeatureFlags.TwoSecondSwapQuotePollingInterval);
  const l2PollingInterval = enableTwoSecondInterval ? 2 * ONE_SECOND_MS : averageL2BlockTimeMs;
  return isMainnetChainId(chainId) ? averageL1BlockTimeMs : l2PollingInterval;
}
